import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Eye, EyeOff, Music } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async ({ email, password }) => {
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.fullName.split(' ')[0]}!`);
      if (user.isFirstLogin) {
        navigate('/change-password');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon">
            <Music size={30} />
          </div>
          <div className="login-title">Swardhara</div>
          <div className="login-sub">Admin Portal · Sign in to continue</div>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label className="form-label">Email Address <span className="req">*</span></label>
            <input
              className={`form-control ${errors.email ? 'error' : ''}`}
              type="email"
              placeholder="admin@swardhara.com"
              autoComplete="email"
              {...register('email', {
                required: 'Email is required',
                pattern: { value: /^\S+@\S+\.\S+$/, message: 'Enter a valid email' }
              })}
            />
            {errors.email && <p className="form-error">{errors.email.message}</p>}
          </div>

          <div className="form-group">
            <label className="form-label">Password <span className="req">*</span></label>
            <div style={{ position: 'relative' }}>
              <input
                className={`form-control ${errors.password ? 'error' : ''}`}
                type={showPwd ? 'text' : 'password'}
                placeholder="Enter your password"
                autoComplete="current-password"
                style={{ paddingRight: '42px' }}
                {...register('password', { required: 'Password is required' })}
              />
              <button
                type="button"
                onClick={() => setShowPwd(v => !v)}
                style={{
                  position: 'absolute', right: '12px', top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none', border: 'none',
                  color: 'var(--grey-400)', cursor: 'pointer',
                  display: 'flex', padding: 0
                }}
              >
                {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            {errors.password && <p className="form-error">{errors.password.message}</p>}
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', marginTop: 8, padding: '11px' }}
          >
            {loading ? <span className="spin" style={{
              display: 'inline-block', width: 16, height: 16,
              border: '2px solid rgba(255,255,255,.4)', borderTopColor: 'white',
              borderRadius: '50%'
            }} /> : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: 'var(--grey-400)' }}>
          © {new Date().getFullYear()} Swardhara — Internal Use Only
        </p>
      </div>
    </div>
  );
}
